module.exports = __webpack_public_path__ + "img/aiapp.82a7f5a5.png";